module.exports = __webpack_public_path__ + "img/Right_up.b9bf6d1e.svg";